import React from "react";
import { profile } from "../data/mock";
import { Phone, Linkedin, FileText, Mail, ArrowUpRight } from "lucide-react";

const Contact = () => {
  const items = [
    {
      label: "Email",
      value: profile.email,
      href: `mailto:${profile.email}`,
      Icon: Mail,
      external: false,
    },
    {
      label: "Phone",
      value: profile.phone,
      href: `tel:${profile.phone.replace(/[^\d]/g, "")}`,
      Icon: Phone,
      external: false,
    },
    {
      label: "LinkedIn",
      value: profile.linkedinLabel,
      href: profile.linkedin,
      Icon: Linkedin,
      external: true,
    },
    {
      label: "Resume",
      value: "Download PDF",
      href: profile.resume,
      Icon: FileText,
      external: true,
    },
  ];

  return (
    <section id="contact" className="relative bg-[#0d0d0d] text-[#f5f3ee] mt-0">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-32">
        <div className="grid grid-cols-12 gap-4 mb-14">
          <div className="col-span-12 md:col-span-3">
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#8a8a85]">
              Contact / 05
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-display text-[44px] md:text-[96px] leading-[0.95] tracking-[-0.03em] max-w-5xl">
              Want to{" "}
              <span className="italic font-serif font-light">connect?</span>
            </h2>
            <p className="mt-6 text-[16px] md:text-[18px] text-[#bdbdb5] max-w-2xl leading-[1.6]">
              I&apos;m currently taking on select creative producing, creative
              direction, and design commissions. The best way to reach me is
              below.
            </p>
          </div>
        </div>

        {/* 2-column direct info list */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 md:gap-x-16 mt-10">
          {items.map((item) => {
            const { Icon } = item;
            return (
              <a
                key={item.label}
                href={item.href}
                target={item.external ? "_blank" : undefined}
                rel={item.external ? "noreferrer" : undefined}
                className="group flex items-start justify-between border-t border-[#2a2a2a] py-6 hover:border-[#f5f3ee] transition-colors duration-300"
              >
                <div className="flex items-start gap-5">
                  <Icon
                    size={18}
                    className="mt-1.5 text-[#8a8a85] group-hover:text-[#f5f3ee] transition-colors duration-300"
                  />
                  <div>
                    <p className="text-[11px] tracking-[0.18em] uppercase text-[#8a8a85] mb-2">
                      {item.label}
                    </p>
                    <p className="text-[18px] md:text-[22px] text-[#f5f3ee] tracking-tight">
                      {item.value}
                    </p>
                  </div>
                </div>
                <ArrowUpRight
                  size={20}
                  className="mt-1.5 text-[#8a8a85] group-hover:text-[#f5f3ee] transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            );
          })}
        </div>
      </div>

      {/* Minimal footer */}
      <footer className="border-t border-[#2a2a2a]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px] text-[#8a8a85]">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-7 h-7 border border-[#8a8a85] text-[#f5f3ee] text-[11px] tracking-tight">
              {profile.monogram}
            </span>
            <span>
              © {new Date().getFullYear()} {profile.name}. All rights reserved.
            </span>
          </div>
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="hover:text-[#f5f3ee] transition-colors duration-200"
          >
            Back to top ↑
          </a>
        </div>
      </footer>
    </section>
  );
};

export default Contact;
